import type { PipeTransform } from '@angular/core';
import { Injectable, Pipe } from '@angular/core';

import type moment from 'moment-timezone';

import { TimeAgoBase } from './timeago';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'rtTimeAgo',
  pure: true,
  standalone: true,
})
export class TimeAgoPipe extends TimeAgoBase implements PipeTransform {
  public transform(
    value?: moment.MomentInput,
    { omitSuffix, shortWithSuffix }: { omitSuffix: boolean; shortWithSuffix?: boolean } = {
      omitSuffix: false,
      shortWithSuffix: false,
    },
  ): string {
    if (!value) {
      return '';
    }

    return this.getTime(value, { omitSuffix, shortWithSuffix });
  }
}
